// Google Ads conversion tracking helpers.
// The Google tag itself is loaded in index.html (AW-17852991454).

const ADS_ACCOUNT_ID = "AW-17852991454";

// Conversion label from Google Ads -> Goals -> Conversions -> "Contact form" action
// -> Tag setup -> "Use Google tag manager" / "Install manually" (the part after the slash
// in send_to, e.g. "AbCdEfGhIjK"). Leave empty until the conversion action exists.
const CONTACT_CONVERSION_LABEL = "";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

export const reportContactConversion = () => {
  if (typeof window === "undefined" || typeof window.gtag !== "function") return;

  // Generic lead event (useful for GA4 / Ads "generate_lead" goals).
  window.gtag("event", "generate_lead", { event_category: "contact", event_label: "contact_form" });

  if (CONTACT_CONVERSION_LABEL) {
    window.gtag("event", "conversion", {
      send_to: `${ADS_ACCOUNT_ID}/${CONTACT_CONVERSION_LABEL}`,
    });
  }
};
